// Room mode selector and current-turn indicator.
import type { Color, RoomMode, RoomState, Role } from '../../types';

type RoomModePanelProps = {
  role: Role;
  displayedTurn: Color;
  selectedMode: RoomMode;
  state: RoomState | null;
  onSelectMode: (mode: RoomMode) => void;
};

export function RoomModePanel({ role, displayedTurn, selectedMode, state, onSelectMode }: RoomModePanelProps) {
  return (
    <section className="panel">
      <div className="turn-chip">{displayedTurn === 'b' ? 'Ход чёрных' : 'Ход белых'}</div>
      {role === 'trainer' && (
        <div className="room-mode">
          <label htmlFor="room-mode-select">Режим работы</label>
          <select
            id="room-mode-select"
            value={selectedMode}
            disabled={state?.mode !== 'lecture' && state?.gameTimer.active}
            onChange={(event) => onSelectMode(event.target.value as RoomMode)}
          >
            <option value="lecture">Лекция и задачи</option>
            <option value="standard">Классические шахматы</option>
            <option value="pawns">Пешечный бой</option>
          </select>
        </div>
      )}
    </section>
  );
}
